module.exports = "/remote-dist/26e28bac03de0bab2a5e8829311dc507.png";